<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="产品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店列表">
          <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流中心" v-if="is_open_logistics">
          <el-select size="small" v-model="searchForm.logistics_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.name" :value="item.logistics_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
         <el-form-item label="导出方式">
          <el-select size="small" v-model="searchForm.export_type" placeholder="请选择">
            <el-option label="按订单" value=""></el-option>
            <el-option label="按产品" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right;">
            <el-button size="small" type="danger" @click="showYundaBatchDelivery" v-auth="'/order/order/operate/batchYundaDelivery'">批量韵达发货</el-button>
          <el-button size="small" type="warning" @click="showBatchDelivery" v-auth="'/order/order/operate/batchDelivery'">批量发货</el-button>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport"  v-auth="'/order/order/operate/export'">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" style="display: inline-block!important;" @click="exportYunda"  v-auth="'/order/order/operate/exportyunda'">韵达导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="primary" @click="importOrder"  v-auth="'/order/order/operate/import'">导入</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'待收货/已发货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
          <el-tab-pane label="取消订单" name="canceling"></el-tab-pane>
          <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        </el-tabs>
        
        <!-- 添加选择状态提示 -->
        <div class="selection-info" v-if="multipleSelection.length > 0">
          已选择 {{ multipleSelection.length }} 个订单
          <el-button size="mini" type="text" @click="clearSelection">清空选择</el-button>
        </div>
        
        <el-table 
          size="small" 
          :data="tableData.data" 
          :span-method="arraySpanMethod" 
          border 
          style="width: 100%" 
          v-loading="loading"
          @selection-change="handleSelectionChange"
          ref="orderTable"
          :row-class-name="tableRowClassName"
        >
          <el-table-column type="selection" width="45" :selectable="selectable"></el-table-column>
          <el-table-column prop="order_no" label="订单信息" width="400" >
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>

                <span class="c_main hand" @click="handleCopy(scope.row.order_no, $event)">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>
              <template v-else>
                  <div class="product-info" v-for="(item, index) in scope.row.product" :key="index"
                   >
                  <div class="pic"><img v-img-url="item.image?item.image.file_path:''" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.user?scope.row.user.nickName:'' }}</div>
              <div class="gray9">ID：({{ scope.row.user? scope.row.user.user_id:'' }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user?scope.row.user.mobile:''}}</span>
              <br />
              <span v-if="scope.row.reserve_date||scope.row.reserve_time">预约时间:{{scope.row.reserve_date?scope.row.reserve_date:''}} {{scope.row.reserve_time?scope.row.reserve_time:''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column prop="logistics" label="发货仓库" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.logistics">{{ scope.row.logistics.name }}({{ scope.row.logistics.logistics_id }})</span>
              <span v-else>平台</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button v-if="(supply_id>0&&supply_setting.order_detail>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
              <el-button
                v-if="(scope.row.pay_type.value == 110) && (scope.row.pay_status.value == 10 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value == 10
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                确认支付
              </el-button>

              <el-button
                v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
              >
                去发货
              </el-button>
              <el-button
                v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 20)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
                @click="addClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/operate/extract'"
              >
                去核销
              </el-button>
              <el-button v-if="scope.row.order_status.value == 21&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/operate/confirmCancel'">去审核</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/order/order/delete'">删除</el-button>

              <el-button v-if="(scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value != 30)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)"
              @click="printClick(scope.row)" type="text"
              size="small" v-auth="'/order/order/genorder'">打印销售单</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
      <div>1、先按未发货条件筛选后，导出订单</div>
      <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
      <div>3、请检查物流公司是否已经添加到系统，<el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
      </div>
      <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
        <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="uploadImage" :show-file-list="false">
          <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
        </el-upload>
      </div>
    </el-dialog>

    <!-- 批量韵达发货弹窗 -->
<el-dialog title="批量韵达发货" :visible.sync="dialogYundaBatchDelivery" width="600px">
  <div style="margin-bottom: 20px;">
    <h4 style="margin-bottom: 10px; color: #409EFF;">操作说明：</h4>
    <div style="line-height: 1.6; color: #666;">
      <p>1. 首先导出订单数据生成韵达发货模板</p>
      <p>2. 在模板中填写完整的发货信息（物流单号、发件人信息等）</p>
      <p>3. 上传填写好的Excel文件进行批量发货</p>
      <p>4. 系统会自动处理发货状态并更新订单信息</p>
    </div>
  </div>

  <el-alert
    title="重要提示"
    type="warning"
    description="请确保Excel文件中的订单号、物流单号等信息准确无误，错误的格式可能导致发货失败。"
    show-icon
    style="margin-bottom: 20px;"
  >
  </el-alert>
  
  <div style="text-align: center; padding: 20px 0; border-top: 1px solid #eee;">
    <el-upload
      class="avatar-uploader"
      action="string"
      accept=".xlsx,.xls"
      :before-upload="onBeforeYundaUpload"
      :http-request="uploadYundaDeliveryFile"
      :show-file-list="false"
      :disabled="yundaUploadLoading"
    >
      <el-button 
        size="small" 
        type="warning" 
        icon="el-icon-upload"
        :loading="yundaUploadLoading"
      >
        {{ yundaUploadLoading ? '上传处理中...' : '上传韵达发货表格' }}
      </el-button>
      <div slot="tip" class="el-upload__tip" style="margin-top: 10px; color: #909399;">
        只能上传xlsx/xls格式的Excel文件，且不超过10MB
      </div>
    </el-upload>
  </div>

  <!-- 选中的订单信息 -->
  <div v-if="multipleSelection.length > 0" style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 4px;">
    <div style="font-weight: bold; margin-bottom: 10px;">当前选中的订单 ({{ multipleSelection.length }}个)：</div>
    <div style="max-height: 120px; overflow-y: auto;">
      <el-tag
        v-for="item in multipleSelection.slice(0, 10)"
        :key="item.order_id"
        size="small"
        style="margin: 2px 5px 2px 0;"
      >
        {{ item.order_no }}
      </el-tag>
      <el-tag v-if="multipleSelection.length > 10" size="small" type="info">
        ... 还有 {{ multipleSelection.length - 10 }} 个订单
      </el-tag>
    </div>
  </div>
</el-dialog>

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import Upload from '@/components/file/import'
import qs from 'qs'
import clip from '@/utils/clipboard'
export default {
  components:{
    Upload
  },
  data() {
    return {
      /*选中的*/
      multipleSelection: [],
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        product_name:"",
        export_type:'',
        order_no: '',
        style_id: '',
        store_id: '',
        create_time: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /* 物流中心 */
      logisticsList:[],
      /* 是否开启物流中心 */
      is_open_logistics:false,
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      supply_id:0,
      supply:{},
       dialogYundaBatchDelivery: false,
    yundaUploadLoading: false,
      open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    printClick(item){
      this.$router.push({
        path: '/order/order/genorder',
        query: {
          id: item.order_id
        }
      });
    },
    // 显示批量韵达发货弹窗
showYundaBatchDelivery() {
  this.dialogYundaBatchDelivery = true;
},

// 韵达发货 - 上传Excel之前验证
onBeforeYundaUpload(file) {
  console.log('韵达上传文件:', file);
  var fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
  const isEXCEL = fileType === 'xlsx' || fileType === 'xls';
  const isLt10M = file.size / 1024 / 1024 < 10;
  
  if (!isEXCEL) {
    this.$message.error('上传文件只能是Excel格式(xlsx或xls)!');
    return false;
  }
  if (!isLt10M) {
    this.$message.error('上传文件大小不能超过 10MB!');
    return false;
  }
  return isEXCEL && isLt10M;
},

// 韵达发货 - 上传Excel文件
uploadYundaDeliveryFile(param) {
  let self = this;
  self.yundaUploadLoading = true;
  
  const loading = this.$loading({
    lock: true,
    text: '正在处理韵达发货数据，请稍候...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  
  let formData = new FormData();
  formData.append('iFile', param.file);
  formData.append('type', 'yunda'); // 标识为韵达发货
  
  OrderApi.batchYundaDelivery(formData)
    .then(response => {
      loading.close();
      self.yundaUploadLoading = false;
      self.dialogYundaBatchDelivery = false;
      
      if (response.code && response.code === 1) {
        self.$message({
          message: response.msg || '韵达批量发货成功',
          type: 'success'
        });
        // 刷新订单列表
        self.getData();
      } else {
        self.$message({
          message: response.msg || '处理完成',
          type: response.code === 0 ? 'warning' : 'info'
        });
      }
    })
    .catch(error => {
      loading.close();
      self.yundaUploadLoading = false;
      self.$message({
        message: error.msg || '韵达批量发货失败',
        type: 'error'
      });
      param.onError();
    });
},
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 1) {
          return [1, 8];
        }
      }
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.clearSelection(); // 切换页面时清空选择
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.clearSelection(); // 切换页面时清空选择
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.clearSelection(); // 切换标签时清空选择
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.shopList = res.data.shop_list;
          self.supply_id = res.data.supply_id;
          if(self.supply_id>0){
            self.supply_setting = res.data.supply.kmd_grade.setting;
          }

          self.logisticsList = res.data.logistics_list;
          self.is_open_logistics = res.data.is_open_logistics
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },
    
    deleteClick(row){
      console.log("row",row);
      let order_id = row.order_id;
      console.log("order_id",order_id);
      let self = this;
      this.$confirm('是否删除当前订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        OrderApi.delete({order_id})
          .then(res => {
            self.$message({
              message: res.msg,
              type: 'warning'
            });
            self.onSubmit();
          }).catch(res => {
            self.$message({
              message: '删除失败',
              type: 'warning'
            });
          });
      })
      .catch(() => {
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.clearSelection(); // 搜索时清空选择
      this.getData();
    },
    
    /*导出*/
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let params = JSON.parse(JSON.stringify(this.searchForm));
      
      // 如果有选中的订单，则导出选中的订单
      if (this.multipleSelection.length > 0) {
        let ids = [];
        this.multipleSelection.map((item)=>{
          // 确保只导出有效的订单ID
          if (item.order_id && !item.is_top_row) {
            ids.push(item.order_id);
          }
        });
        
        if (ids.length > 0) {
          params.ids = ids.join(",");
          console.log('导出选中的订单ID:', ids);
        } else {
          console.log('没有有效的订单ID');
        }
      } else {
        console.log('导出全部订单');
      }
      
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(params);
    },
    
    /*韵达导出*/
    exportYunda: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let params = JSON.parse(JSON.stringify(this.searchForm));
      
      // 如果有选中的订单，则导出选中的订单
      if (this.multipleSelection.length > 0) {
        let ids = [];
        this.multipleSelection.map((item)=>{
          // 确保只导出有效的订单号
          if (item.order_no && !item.is_top_row) {
            ids.push(item.order_no);
          }
        });
        
        if (ids.length > 0) {
          params.ids = ids.join(",");
          console.log('韵达导出选中的订单号:', ids);
        }
      }
      
      window.location.href = baseUrl + '/index.php/shop/order.operate/exportYunda?' + qs.stringify(params);
    },

    // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
    
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'upload') {
        this.open_upload = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
    
    // 显示批量发货说明
    showBatchDelivery() {
      this.dialogBatchDelivery = true;
    },
    
    /*跳转物流公司*/
    gotoExpress() {
      let self = this;
      self.$router.push('/setting/express/index');
    },

    /*选择图片之前*/
    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

    /*上传图片*/
    uploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append('iFile', param.file);
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close();
          self.dialogBatchDelivery = false;
          self.$message({
            message: response.msg,
            type: 'warning'
          });
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          });
          param.onError();
        });
    },

    handleCopy(text, event) {
      clip(text, event)
    },
    
    /* 新增的选择相关方法 */
    
    // 控制哪些行可以选择
    selectable(row, index) {
      // 只有非表头行（商品行）可以选择
      return !row.is_top_row;
    },
    
    // 设置行类名
    tableRowClassName({row, rowIndex}) {
      // 为表头行添加特殊类名，用于隐藏选择框
      if (row.is_top_row) {
        return 'hide-selection';
      }
      return '';
    },
    
    // 多选模式下的选择变化
    handleSelectionChange(selection) {
      console.log('原始选择:', selection);
      // 过滤掉表头行（is_top_row为true的行）和没有order_id的行
      this.multipleSelection = selection.filter(item => {
        return !item.is_top_row && item.order_id;
      });
      console.log('过滤后的选择:', this.multipleSelection);
    },
    
    // 清空选择
    clearSelection() {
      this.multipleSelection = [];
      // 清除el-table的选中状态
      if (this.$refs.orderTable) {
        this.$refs.orderTable.clearSelection();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

/* 新增的选择信息样式 */
.selection-info {
  padding: 8px 16px;
  background-color: #f0f9ff;
  border: 1px solid #bee3f8;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #2c5282;
}
/* 韵达发货弹窗样式 */
.avatar-uploader {
  display: inline-block;
}

.el-upload__tip {
  font-size: 12px;
}

/* 选中订单标签样式 */
.selected-orders {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 10px;
  background: #fafafa;
}

/* 隐藏表头行的选择框 */
::v-deep .hide-selection .el-table__selection {
  display: none;
}
::v-deep .hide-selection .el-checkbox {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/order/order/index.vue